import React from "react";
import { Card } from "@/components/ui/card";

const BusinessImpactSection = () => {
  const metrics = [
    {
      value: "80%",
      label: "Reduction in investigation time"
    },
    {
      value: "60%",
      label: "Fewer false positives"
    },
    {
      value: "3x",
      label: "Analyst productivity increase"
    },
    {
      value: "100%",
      label: "Intelligence retention"
    }
  ];

  return (
    <section className="py-16 md:py-20 bg-gradient-to-r from-[#a855f7] to-[#8b5cf6]">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-6xl mx-auto space-y-12">
          <div className="text-center">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
              Measurable Business Impact
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {metrics.map((metric, index) => (
              <Card key={index} className="p-8 text-center hover:shadow-lg transition-shadow bg-white/10 border-2 border-white/20 hover:border-white/40 backdrop-blur-sm">
                <div className="space-y-3">
                  <div className="text-5xl font-bold text-white">{metric.value}</div>
                  <p className="text-lg text-white font-medium">{metric.label}</p>
                </div>
              </Card>
            ))}
          </div>

          <div className="text-center pt-6">
            <p className="text-xl md:text-2xl font-semibold text-white">
              AuraXP transforms cybersecurity into a self-learning, self-defending system that evolves faster than adversaries.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessImpactSection;
